import { render, staticRenderFns } from "./site-listings-item.vue?vue&type=template&id=c2c4c3c0&scoped=true"
import script from "./site-listings-item.vue?vue&type=script&lang=js"
export * from "./site-listings-item.vue?vue&type=script&lang=js"
import style0 from "./site-listings-item.vue?vue&type=style&index=0&id=c2c4c3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4c3c0",
  null
  
)

export default component.exports